import { assertBreakoutMessage, assertSocketMessage } from './socket-worker/assertions';
import { IncomingTypes, IncomingMessage, MessageTypes } from './socket-worker/types';
import { SocketManager } from './socket-worker/socket-manager';
import { isObject } from 'underscore';

const manager = new SocketManager();

const handleMessageFromUiThread = ({ data }: MessageEvent<IncomingMessage>) => {
	try {
		if (data.type === MessageTypes.end) {
			manager.end();
			return;
		}

		const channel = manager.getChannel(data.channel, data.options);

		switch (data.type) {
			case MessageTypes.getConnection: {
				manager.connectChannel(data.channel, data.options);
				break;
			}
			case MessageTypes.disconnect: {
				manager.removeChannel(data.channel, data.options);
				break;
			}
			case MessageTypes.sendMessage: {
				assertSocketMessage(data.message);
				channel?.sendMessage(data.message);

				break;
			}
			case MessageTypes.getCurrentlyWatching: {
				channel?.getCurrentlyWatching((viewers) => {
					self.postMessage({ type: IncomingTypes.currentlyWatching, viewers, _ns: data.channel });
				});
				break;
			}
			case MessageTypes.sendBreakoutData: {
				assertBreakoutMessage(data.message);
				const { sessionUuid, breakoutUuid, opentokId, host } = data.message;
				channel?.sendBreakoutData(sessionUuid, breakoutUuid, opentokId, host);

				break;
			}
			case MessageTypes.updateWorkingEvent: {
				if (data.options?.admin) {
					channel?.updateWorkingEvent(data.options.admin);
				}

				break;
			}
			case MessageTypes.requestBacklog: {
				if (isObject(data.message) && 'after' in data.message && data.message.after) {
					channel?.requestBacklog(data.message.after);
				}
				break;
			}
			default: {
				throw new Error(`Undefined socket message sent ${JSON.stringify(data)}`);
			}
		}
	} catch (e) {
		console.error('Socket message error', e);
	}
};

self.onmessage = handleMessageFromUiThread;